import React from 'react'

import { flow, orderBy } from 'lodash'
import { createSelector } from 'reselect'

import { ALL_ITEM } from 'src/constants'
import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

const caregiverManagement$ = (state) => state.admin.caregiverManagement

export const caregiverList$ = createSelector(
  caregiverManagement$,
  ({ caregiverList = [] }) =>
    caregiverList.map((item) => {
      const label = [item.firstName, item.middleName, item.lastName]
        .filter((item) => item)
        .join(' ')

      return {
        ...item,
        label,
        title: label,
        value: item.uuid
      }
    })
)

export const caregiverListWithAll$ = createSelector(
  caregiverManagement$,
  ({ caregiverList = [] }) => {
    const formattedList = caregiverList.map((item) => ({
      ...item,
      title: [item.firstName, item.middleName, item.lastName]
        .filter((item) => item)
        .join(' '),
      value: item.uuid
    }))

    return addAllValue([...formattedList], true)
  }
)

export const companyCaregiversOrderByEnabledWithAll$ = createSelector(
  caregiverManagement$,
  ({ caregiverList = [] }) =>
    flow(
      (caregiverList) =>
        caregiverList.map((item) => ({
          ...item,
          fullName: `${item.firstName} ${item.middleName || ''} ${
            item.lastName
          }`
        })),
      (caregiverList) =>
        caregiverList.map((item) => ({
          ...item,
          enabled: +item.enabled,
          fullName: item.enabled ? (
            <span style={{ wordBreak: 'break-all' }}>{item.fullName}</span>
          ) : (
            <span
              style={{
                fontStyle: 'italic',
                wordBreak: 'break-all'
              }}>{`${item.fullName} (inactive)`}</span>
          ),
          searchField: item.enabled
            ? item.fullName
            : `${item.fullName} (inactive)`
        })),
      (caregiverList) => orderBy(caregiverList, ['enabled'], ['desc']),
      (caregiverList) => addAllValue(caregiverList, true, 'All Caregivers')
    )(caregiverList)
)

export const companyCaregiversOrderByEnabledWithAllV5$ = createSelector(
  caregiverManagement$,
  ({ caregiverList = [] }) =>
    flow(
      (caregiverList) =>
        caregiverList.map((item) => ({
          ...item,
          fullName: `${item.firstName} ${item.middleName || ''} ${
            item.lastName
          }`
        })),
      (caregiverList) =>
        caregiverList.map((item) => ({
          ...item,
          enabled: +item.enabled,
          fullName: item.enabled ? (
            <span style={{ wordBreak: 'break-all' }}>{item.fullName}</span>
          ) : (
            <span
              style={{
                fontStyle: 'italic',
                wordBreak: 'break-all'
              }}>{`${item.fullName} (inactive)`}</span>
          ),
          searchField: item.enabled
            ? item.fullName
            : `${item.fullName} (inactive)`
        })),
      (caregiverList) => orderBy(caregiverList, ['enabled'], ['desc']),
      (caregiverList) =>
        addAllValueV5({
          list: caregiverList,
          convertList: true,
          allItem: {
            key: 'all',
            title: 'All Caregivers',
            label: 'All Caregivers',
            value: '',
            children: []
          }
        })
    )(caregiverList)
)

export const caregiverEdit$ = createSelector(
  caregiverManagement$,
  ({ caregiverEdit = {} }) => caregiverEdit
)

export const caregiversSelectWithAll$ = createSelector(
  caregiverList$,
  (caregiverList = []) => [ALL_ITEM, ...caregiverList]
)
